<template>
  <div class="container-wrapper">
    <div ref="container" :class="{ container: true, mobile, desktop: !mobile }">
      <!-- {{breakpoint}} -->
      <div v-if="!loaded" class="loading-container">
        <div class="loading-inner">
          <div v-if="!(initialLoad && mobile)" >Loading</div>
          <div v-if="!(initialLoad && mobile)" class="loader"/>
          <div v-if="initialLoad && mobile" class="tap" @click="start()">Tap to continue</div>
        </div>
      </div>
      <div :style="{ display: scrollCount % 2 === 0 ? 'block' : 'none' }" ref="scroller" class="scroll-container">
        <div class="scroll-inner"/>
      </div>
      <img @click="toggleMute" :src="require(`../assets/images/volume_${muted ? 'off' : 'up'}-24px.svg`)" class="mute-icon" />
      <canvas ref="canvas" :width="mobile ? 810 : 1920" height="1080"/>
      <div class="still-container">
        <img v-show="breakpoint.index === Labels.HPT_START + (i - 1) && canScroll" v-for="i in 6" :key="i" :src="require(`../assets/images/stills/${i - 1}${mobile ? 'm' : ''}.${(i - 1 === 0 && !mobile) ? 'png' : 'jpg'}`)"/>
      </div>
      <div v-show="loaded" class="overlay" ref="overlay" :style="{ fontSize: `${scale * 16}px` }">

        <div class="gradient" data-type="Gradient" :data-start="Times[Labels.START]" :data-end="Times[Labels.START] + 250"/>

        <!---->
        <div v-if="!mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.START]" :data-end="Times[Labels.START] + 81">
          <div class="hover-line">Want guacamole whenever,</div>
          <div class="hover-line">wherever without adding any</div>
          <div class="hover-line">nasty preservatives?</div>
        </div>
        <div v-if="mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.START]" :data-end="Times[Labels.START] + 81">
          <div class="hover-line">Want guacamole</div>
          <div class="hover-line">whenever, wherever</div>
          <div class="hover-line">without adding any</div>
          <div class="hover-line">nasty preservatives?</div>
        </div>

        <!---->
        <div v-if="!mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.START] + 93" :data-end="Times[Labels.START] + 143">
          <div class="hover-line">Us too!</div>
        </div>
        <div v-if="mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.START] + 93" :data-end="Times[Labels.START] + 143">
          <div class="hover-line">Us too!</div>
        </div>

        <!---->
        <div v-if="!mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.START] + 155" :data-end="Times[Labels.START] + 236">
          <div class="hover-line">We found a way to make great</div>
          <div class="hover-line">guac when you want it, with no</div>
          <div class="hover-line">preservatives added.</div>
        </div>
        <div v-if="mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.START] + 155" :data-end="Times[Labels.START] + 236">
          <div class="hover-line">We found a way to</div>
          <div class="hover-line">make great guac when</div>
          <div class="hover-line">you want it, with no</div>
          <div class="hover-line">preservatives added.</div>
        </div>

        <!---->
        <div v-if="!mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.PROBLEMATIC]" :data-end="Times[Labels.PROBLEMATIC] + 4">
          <div class="hover-line">It all starts with avocados.</div>
          <div class="spacer"/>
          <div class="hover-line">Picking them perfectly ripe can</div>
          <div class="hover-line">be a problematic business.</div>
        </div>
        <div v-if="mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.PROBLEMATIC]" :data-end="Times[Labels.PROBLEMATIC] + 4">
          <div class="hover-line">It all starts with</div>
          <div class="hover-line">avocados.</div>
          <div class="spacer"/>
          <div class="hover-line">Picking them</div>
          <div class="hover-line">perfectly ripe can</div>
          <div class="hover-line">be a problematic</div>
          <div class="hover-line">business.</div>
        </div>

        <!---->
        <div class="hover-copy alt ch1" data-type="HoverCopy" :data-start="Times[Labels.HARD] - 1" :data-end="Times[Labels.HARD] + 3">
          <div class="hover-line">too hard.</div>
        </div>

        <!---->
        <div v-if="!mobile" class="hover-copy alt ch2" data-type="HoverCopy" :data-start="Times[Labels.MUSHY] - 1" :data-end="Times[Labels.MUSHY] + 3">
          <div class="hover-line">too soft, brown, and mushy.</div>
        </div>
        <div v-if="mobile" class="hover-copy alt ch2" data-type="HoverCopy" :data-start="Times[Labels.MUSHY] - 1" :data-end="Times[Labels.MUSHY] + 3">
          <div class="hover-line">too soft, brown,</div>
          <div class="hover-line">and mushy.</div>
        </div>

        <!---->
        <div class="hover-copy alt ch3" data-type="HoverCopy" :data-start="Times[Labels.BRUISED] - 1" :data-end="Times[Labels.BRUISED] + 3">
          <div class="hover-line">bruised.</div>
        </div>

        <!---->
        <div v-if="!mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.PERFECT] - 1" :data-end="Times[Labels.PERFECT] + 3">
          <div class="hover-line">You name it, it's an issue.</div>
          <div class="spacer"/>
          <div class="hover-line">We pick only perfect</div>
          <div class="hover-line">avocados for our products.</div>
        </div>
        <div v-if="mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.PERFECT] - 1" :data-end="Times[Labels.PERFECT] + 3" data-stagger="no">
          <div class="hover-line">You name it,</div>
          <div class="hover-line">it's an issue.</div>
          <div class="spacer"/>
          <div class="hover-line">We pick only</div>
          <div class="hover-line">perfect avocados</div>
          <div class="hover-line">for our products.</div>
        </div>
        
        <!---->
        <div v-show="packagingState < 2" ref="scaleBubble" class="bubble bubble1" data-packaging="true" data-type="Bubble" :data-start="Times[Labels.PERFECT_BUBBLE] - 1" :data-end="Times[Labels.PERFECT_BUBBLE] + 3" :data-rotation="mobile ? '65deg' : '-10deg'">
          <div class="backdrop">
            <div class="circle"/>
            <div class="triangle"/>
          </div>
          <div class="bubble-copy">
            <span :class="{'bubble-letter': true, superscript: letter === '®' }" :key="`${i}-${letter}`" v-for="(letter, i) in `And how does WHOLLY® GUACAMOLE stay so good and green without preservatives?`">{{letter}}</span>
          </div>
        </div>

        <!---->
        <div ref="packaging" class="packaging-container">
          <packaging-slide v-show="inPackagingSection" :mobile="mobile" :showDescription="packagingState > 1" :end="packagingState > 2"/>
        </div>

        <!---->
        <div class="bubble bubble2" data-type="Bubble" :data-start="Times[Labels.NERVOUS] - 1" :data-end="Times[Labels.NERVOUS] + 3" :data-rotation="mobile ? '-95deg' : '-160deg'">
          <div class="backdrop">
            <div class="circle"/>
            <div class="triangle"/>
          </div>
          <div class="bubble-copy">
            <span class="bubble-letter" :key="`${i}-${letter}`" v-for="(letter, i) in `Did someone say high pressure?\uFFFFI can't take it!`" v-html="letter.replace(/\uFFFF/g, `<div style='height: 0.4em'></div>`)"/>
          </div>
        </div>

        <!---->
        <div v-if="!mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.NO_FEAR] - 1" :data-end="Times[Labels.NO_FEAR] + 10">
          <div class="hover-line">Don't be afraid!</div>
          <div class="spacer"/>
          <div class="hover-line">hPT seals in the good stuff with</div>
          <div class="hover-line">purified water, high pressure, and</div>
          <div class="hover-line">no heat.</div>
        </div>
        <div v-if="mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.NO_FEAR] - 1" :data-end="Times[Labels.NO_FEAR] + 10">
          <div class="hover-line">Don't be afraid!</div>
          <div class="spacer"/>
          <div class="hover-line">hPT seals in the good</div>
          <div class="hover-line">stuff with purified</div>
          <div class="hover-line">water, high pressure, </div>
          <div class="hover-line">and no heat.</div>
        </div>
        
        <!---->
        <div v-if="!mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.NO_PRESERVATIVES] - 1" :data-end="Times[Labels.NO_PRESERVATIVES] + 3">
          <div class="hover-line">It keeps Wholly® Guacamole</div>
          <div class="hover-line">good without preservatives.</div>
        </div>
        <div v-if="mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.NO_PRESERVATIVES] - 1" :data-end="Times[Labels.NO_PRESERVATIVES] + 3">
          <div class="hover-line">It keeps</div>
          <div class="hover-line">Wholly® Guacamole</div>
          <div class="hover-line">good without</div>
          <div class="hover-line">preservatives.</div>
        </div>
        
        <!---->
        <div v-if="!mobile" class="hover-copy ch4" data-type="HoverCopy" :data-start="Times[Labels.NONE] - 15" :data-end="Times[Labels.NONE] + 3">
          <div class="hover-line">None whatsoever.</div>
        </div>
        <div v-if="mobile" class="hover-copy ch4" data-type="HoverCopy" :data-start="Times[Labels.NONE] - 15" :data-end="Times[Labels.NONE] + 3">
          <div class="hover-line">None</div>
          <div class="hover-line">whatsoever.</div>
        </div>
        
        <!---->
        <div v-if="!mobile" class="hover-copy brs1" data-type="HoverCopy" :data-start="Times[Labels.BENNY_1] - 1" :data-end="Times[Labels.BENNY_1] + 3">
          <div class="hover-line">That keeps the bad bacteria</div>
        </div>
        <div v-if="mobile" class="hover-copy brs1" data-type="HoverCopy" :data-start="Times[Labels.BENNY_1] - 1" :data-end="Times[Labels.BENNY_1] + 3">
          <div class="hover-line">That keeps the bad</div>
          <div class="hover-line">bacteria</div>
        </div>
        
        <!---->
        <div class="hover-copy brs2" data-type="HoverCopy" :data-start="1179" :data-end="1183">
          <div class="hover-line">from doing their thing,</div>
        </div>
        
        <!---->
        <div class="hover-copy source" data-click="Legal" data-type="HoverCopy" :data-start="Times[Labels.SOURCE] + 30" :data-end="Times[Labels.SOURCE] + 150">
          <div class="hover-line">source</div>
        </div>

        <!---->
        <div class="bubble bubble3" data-type="Bubble" :data-start="Times[Labels.MARVELOUS] - 1" :data-end="Times[Labels.MARVELOUS] + 3" :data-rotation="mobile ? '0deg' : '-15deg'">
          <div class="backdrop">
            <div class="circle"/>
            <div class="triangle"/>
          </div>
          <div class="bubble-copy">
            <span class="bubble-letter" :key="`${i}-${letter}`" v-for="(letter, i) in `It's pretty marvelous what you can do under a little pressure.`">{{letter}}</span>
          </div>
        </div>
        
        <!---->
        <div v-if="!mobile" class="hover-copy" data-type="HoverCopy" :data-start="Times[Labels.AGAIN] - 1" :data-end="Times[Labels.AGAIN] + 2" data-final="final">
          <div class="hover-line">And if we've said it before,</div>
          <div class="spacer"/>
          <div class="hover-line">we'll say it again.</div>
        </div>
        <div v-if="mobile" class="hover-copy end-line" data-type="HoverCopy" :data-start="Times[Labels.AGAIN] - 1" :data-end="Times[Labels.AGAIN] + 2" data-final="final">
          <div class="hover-line">And if we've said it</div>
          <div class="hover-line">before,</div>
          <div class="spacer"/>
          <div class="hover-line">we'll say it again.</div>
        </div>
        
        <!---->
        <div class="intro" data-type="Intro" :data-start="Times[Labels.WONDERFUL_WORLD] - 20" :data-end="Times[Labels.PROBLEMATIC]"/>
        <div class="outro" data-type="Outro" :data-start="Times[Labels.LTATU] - 1" :data-end="Times[Labels.LTATU] + 3"/>
      </div>
      <div class="nav-dots">
        <div class="dot" @click="transition(section.time)" :class="{ active: sectionId === i }" :style="{ color: section.color, backgroundColor: section.color }" :key="`${i}-${section.name}`" v-for="(section, i) in sections"></div>
      </div>
      <div @click="didScroll('down')" :class="{ 'scroll-indicator': true, active: (!waitingAnimation && canScroll) || (waiting && breakpoint !== (Labels.length - 1)) }">
        <img :src="require('../assets/images/indicator.svg')"/>
      </div>
    </div>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js-legacy'
import { CurveInterpolator } from 'curve-interpolator'
import { gsap } from 'gsap'
import { Breakpoints, Sections, Labels, Times, Sounds } from '../scripts/Constants'
import { load, createSprites, TextureCache } from '../scripts/Loader'
import Vue from 'vue'
import Color from 'color'
import AudioManager from '../scripts/AudioManager'

import PackagingSlide from '../components/PackagingSlide'

export default {
  name: 'WhollyGuacamole',
  components: {
    PackagingSlide,
  },
  created () {
    this.Labels = Labels
    this.Times = Times
  },
  data () {
    return {
      canPlay: false,
      loadedAndInited: false,
      scrollCount: 0,
      breakpoint: { index: 0, time: 0 },
      scale: 1,
      initialLoad: false,
      loaded: false,
      currentFrame: 0,
      packagingState: 0,
      inPackagingSection: false,
      mobile: false,
      sectionId: 0,
      waiting: false,
      muted: true,
      waitingAnimation: false,
      canScroll: false,
      sections: Object.keys(Sections).map(key => {
        const section = Sections[key]
        return {
          name: key,
          breakpoint: section.breakpoint,
          time: section.time,
          color: section.color
        }
      }).sort((a, b) => a.time - b.time)
    }
  },
  mounted () {
    this.videoOpQueue = []
    this.$refs.container.addEventListener('click', this.onClickExperience)
    setTimeout(() => {
      this.app = new PIXI.Application({ view: this.$refs.canvas, width: 1920, height: 1080, antialias: true })
      this.timeoutQueue = []
      this.tweens = []
      this.mobile = this.isMobile()
      this.particleSneak = 0
      this.init().then(() => {
        load().then(() => {
          this.attachScroll()
          this.app.stage.addChild(this.spriteVideo)
          this.app.ticker.add(this.render)
          this.initScene()
          this.initTimeline()
          this.start()
          this.attachListeners()
          this.loadedAndInited = true
          this.video.play()
        })
      })
    }, 250)
  },
  beforeDestroy () {
    this.unmounted = true
  },
  methods: {
    toggleMute () {
      this.muted = !this.muted
      if (this.muted) {
        AudioManager.mute()
      } else {
        AudioManager.unmute()
      }
    },

    attachListeners () {
      this.resize()
      window.addEventListener('resize', this.resize)
    },

    start () {
      this.started = true
      this.waiting = false
      this.waitingAnimation = false
      this.sounds = Sounds.map(sound => ({ ...sound, triggered: false }))
      this.breakpoints = Breakpoints.map((bp, i) => ({ ...bp, triggered: i === 0, opFired: false }))
      setTimeout(() => this.initialLoad = true, 500)
    },

    getNextBreakpoint () {
      // console.log(this.breakpoints.map(bp => bp.triggered))
      return this.breakpoints.filter(bp => !bp.skip).find(bp => !bp.triggered)
    },

    getNextSound () {
      // console.log(this.breakpoints.map(bp => bp.triggered))
      return this.sounds.find(bp => !bp.triggered)
    },

    transition (time) {
      if (!this.transitioning) {
        this.transitioning = true
        this.zoomScaler = 0
        this.particleSneak = 0
        this.outroPlayed = false
        this.clearTimeoutQueue()
        gsap.to(this.$refs.container, 0.2, { autoAlpha: 0, onComplete: () => {
          this.breakpoints.forEach((breakpoint, i) => {
            breakpoint.opFired = false
            breakpoint.triggered = (breakpoint.time < time) || (i === 0)
          })
          this.sounds.forEach(sound => {
            AudioManager.stop(sound.key)
            sound.playing = false
            sound.triggered = sound.start / 30 < time
          })
          this.setTime(time, true).then(() => {
            this.refreshScene()
            this.removeTimeline()
            this.initTimeline()
            this.waiting = false
            this.waitingAnimation = false
            this.playVideo().then(() => this.transitioning = false)
            setTimeout(() => gsap.to(this.$refs.container, 0.2, { autoAlpha: 1 }), 300)
          })
        }})
      }
    },

    removeTimeline () {
      gsap.globalTimeline.clear()
      this.tweens.forEach(tween => {
        tween.pause()
        tween.seek(0)
        tween.kill()
      })
      this.tweens = []
      this.timeline.clear()
      this.timeline = null
      this.clearTimeoutQueue()
    },

    clearTimeoutQueue () {
      this.timeoutQueue.forEach(cb => clearTimeout(cb))
      this.timeoutQueue = []
    },

    resize () {
      const mobile = this.mobile
      const bounds = this.$refs.container.getBoundingClientRect()
      this.mobile = this.isMobile()
      const targetRatio = (this.mobile ? 810 : 1920) / 1080
      const currentRatio = bounds.width / bounds.height

      if (targetRatio > currentRatio) {
        this.scale = Math.min(bounds.width * 1.80, bounds.height) / 1080
      } else {
        this.scale = bounds.width / (this.mobile ? 810 : 1920)
      }

      this.scale *= this.mobile ? 0.75 : 1

      this.app.renderer.resize(this.mobile ? 810 : 1920, 1080)
      if (mobile !== this.mobile) {
        // if we get here then hide everything while it reloads
        this.$refs.container.style.visibility = 'hidden'
        window.location.reload()
      }
    },

    async init () {
      await this.initVideo(require(`../assets/${this.mobile ? 'guac-mobile' : 'guac'}.mp4`))
      this.initTextures(this.mobile ? 810 : 1920, 1080)
    },

    playVideo () {
      return new Promise(resolve => {
        const op = {
          name: 'playVideo',
          running: false,
          resolved: false,
          fn: () => {
            op.running = true
            const onPlay = () => {
              this.video.removeEventListener('playing', onPlay)
              op.resolved = true
              resolve()
            }
            if (!this.video.paused) {
              onPlay()
            } else {
              this.video.addEventListener('playing', onPlay)
              this.video.play()
            }
          }
        }
        this.videoOpQueue.push(op)
      })
    },

    pauseVideo () {
      return new Promise(resolve => {
        const op = {
          name: 'pauseVideo',
          running: false,
          resolved: false,
          fn: () => {
            op.running = true
            const onPause = () => {
              this.video.removeEventListener('pause', onPause)
              op.resolved = true
              this.baseTexture.update()
              resolve()
            }
            if (this.video.paused) {
              onPause()
            } else {
              this.video.addEventListener('pause', onPause)
              this.video.pause()
            }
          }
        }
        this.videoOpQueue.push(op)
      })
    },

    setTime (time) {
      return new Promise(resolve => {
        const op = {
          name: `setTime ${time}`,
          running: false,
          resolved: false,
          fn: () => {
            op.running = true
            const onSeek = () => {
              this.video.removeEventListener('seeked', onSeek)
              op.resolved = true
              this.baseTexture.update()
              resolve()
            }

            const onPause = () => {
              this.video.removeEventListener('pause', onPause)
              // console.log('onPause', this.video.currentTime, time)
              if (this.video.currentTime === time) {
                onSeek()
              } else {
                this.video.addEventListener('seeked', onSeek)
                this.video.currentTime = time
              }
            }

            if (this.video.paused) {
              onPause()
            } else {
              this.video.addEventListener('pause', onPause)
              this.video.pause()
            }
          }
        }
        this.videoOpQueue.push(op)
      })
    },

    initVideo (src) {
      this.video = document.createElement('video')
      window.video = this.video
      this.video.addEventListener('playing', () => {
        if (this.loaded) {
          return
        }
        if (!this.loadedAndInited) {
          this.video.pause()
          return
        }
        setTimeout(() => {
          // console.log('loaded')
          this.loaded = true
        }, 300)
      })
      this.video.setAttribute('webkit-playsinline', '')
      this.video.setAttribute('autoplay', '')
      this.video.setAttribute('playsinline', '')
      this.video.setAttribute('muted', '')
      this.video.autoplay = 'autoplay'
      this.video.playsinline = 'playsinline'
      this.video.muted = 'muted'
      this.video.src = src
    },

    initTextures (width, height) {
      this.baseTexture = new PIXI.BaseTexture(this.video)
      window.tex = this.baseTexture
      if (this.mobile) {
        this.textureVideo = new PIXI.Texture(this.baseTexture, new PIXI.Rectangle(0, 0, width, height))
        this.textureMask = new PIXI.Texture(this.baseTexture, new PIXI.Rectangle(width, 0, width, height))
      } else {
        this.textureVideo = new PIXI.Texture(this.baseTexture, new PIXI.Rectangle(0, height, width, height))
        this.textureMask = new PIXI.Texture(this.baseTexture, new PIXI.Rectangle(0, 0, width, height))
      }
      this.spriteVideo = new PIXI.Sprite(this.textureVideo)
      this.spriteMask = new PIXI.Sprite(this.textureMask)
    },

    refreshScene () {
      if (this.particleContainer) {
        this.app.stage.removeChild(this.particleContainer)
      }
      this.app.stage.removeChild(this.introContainer)
      this.app.stage.removeChild(this.intro)
      this.app.stage.removeChild(this.burst)
      this.app.stage.removeChild(this.outro)
      this.initScene()
    },

    initScene () {
      const sprites = createSprites(this.mobile)
      this.intro = sprites.intro
      this.burst = sprites.burst
      this.outro = sprites.outro
      this.outro.visible = false
      this.introContainer = new PIXI.Container()
      this.introContainer.x = (this.mobile ? 810 : 1920) / 2
      this.introContainer.y = 1080 / 2
      this.introContainer.pivot.x = (this.mobile ? 810 : 1920) / 2
      this.introContainer.pivot.y = 1080 / 2
      this.initParticles()
      this.app.stage.addChild(this.introContainer)
      this.introContainer.addChild(this.intro)
      this.introContainer.addChild(this.burst)
      this.app.stage.addChild(this.outro)
    },

    playOutro () {
      if (!this.outroPlayed) {
        this.outroPlayed = true
        this.finalCopyOutTransition()
        AudioManager.playSound('whoosh-2', 0.25)
        setTimeout(() => {
          this.outro.visible = true
          this.outro.play()
        }, 350)
      }
    },

    initParticles () {
      if (!(this.app.renderer instanceof PIXI.CanvasRenderer)) {
        this.particleContainer = new PIXI.Container()
        this.particleContainer.mask = this.spriteMask
        this.app.stage.addChild(this.particleContainer)
        this.seed = 4
        this.target = [0, 0]
        this.targetValues = [...new Array(20)].map(() => [this.random(), this.random()])
        this.targetCurve = new CurveInterpolator(this.targetValues, { closed: true, tension: -2 })
        for (let i = 0; i < (this.mobile ? 500 : 500); i++) {
          const texture = TextureCache.get(`Bacteria-0${this.random() * 8 + 1 | 0}.png`)
          const particle = new PIXI.Container()
          const sR = (this.random() ** 8 * 0.31)

          const sprite = new PIXI.Sprite(texture)
          const glow = new PIXI.Sprite(TextureCache.get(`ball_glow.png`))
          const hue = this.random() * 360 | 0
          sprite.anchor.x = 0.5
          sprite.anchor.y = 0.5
          glow.anchor.x = 0.5
          glow.anchor.y = 0.5
          glow.tint = Color(`hsl(${hue}, 100%, 50%)`).rgbNumber()
          glow.blendMode = PIXI.BLEND_MODES.ADD
          sprite.tint = Color(`hsl(${hue}, 100%, 80%)`).rgbNumber()
          particle.addChild(sprite)
          particle.addChild(glow)
          particle.__glow = glow
          particle.__sprite = sprite
          particle.points = [...new Array(5)].map(() => [this.random(), this.random(), this.random()])
          particle.curve = new CurveInterpolator(particle.points, { closed: true, tension: -2 })
          particle.t = 0
          particle.random = this.random()
          particle.pulseSpeed = this.random() * 1.5 + 0.5
          particle.scale.x = 0.09 + sR
          particle.scale.y = 0.09 + sR
          particle.direction = this.random() * Math.PI * 2
          particle.speed = (this.random() * 0.5 + 0.5) * 0.5 * sR * 3 + 0.1
          particle.spin = this.random() * 0.1 - 0.05
          particle.spin += Math.sign(particle.spin) * 0.01
          particle.swingScale = this.random() * sR * 3 + 0.1
          this.particleContainer.addChild(particle)
        }
      } else {
        this.particleContainer = null
      }
    },

    initTimeline () {
      this.clickAttachments = []
      this.inPackagingSection = false
      this.enteredPackagingSection = false
      this.packagingState = 0
      this.timeline = gsap.timeline({ paused: true })
      this.$refs.overlay.children.forEach(child => {
        const start = parseFloat(child.dataset.start) / 30
        const end = parseFloat(child.dataset.end) / 30
        const noStagger = !!child.dataset.stagger
        if (child.dataset.packaging) {
          this.timeline.add(() => this.enteredPackagingSection = true, start)
          this.timeline.add(() => this.enteredPackagingSection = false, end)
        }
        if (child.dataset.click) {
          this.clickAttachments.push({ child, cb: this[`onClick${child.dataset.click}`] })
        }
        if (child.dataset.type) {
          this[`timeline${child.dataset.type}`](child, start, end, noStagger, !!child.dataset.final)
        }
      })
    },

    timelineGradient (child, start, end) {
      this.timeline.fromTo(child, 0.5, { autoAlpha: 0 }, { autoAlpha: 1 }, start)
      this.timeline.fromTo(child, 0.5, { autoAlpha: 1 }, { autoAlpha: 0 }, end)
    },

    timelineHoverCopy (child, start, end, noStagger = false, isFinal = false) {
      this.timeline.fromTo([...child.children].filter(child => !child.classList.contains('spacer')), start, { y: '1em', autoAlpha: 0 }, { y: '1em', autoAlpha: 0 }, 0)
      this.timeline.add(() => {
        // console.log('starting', child)
        this.tweens.push(gsap.to(child.children, 0.25, { y: 0, autoAlpha: 1, ease: 'power1.out', stagger: noStagger ? 0 : 0.1, onStart: () => this.waitingAnimation = true, onComplete: () => this.waitingAnimation = false }))
      }, start)
      const out = () => {
        // console.log('ending', child)
        this.tweens.push(gsap.to(child.children, 0.25, { y: '-0.75em', autoAlpha: 0, ease: 'power1.out', stagger: noStagger ? 0 : 0.1 }))
      }
      if (isFinal) {
        this.finalCopyOutTransition = out
      }
      this.timeline.add(out, end)
    },

    timelineBubble (child, start, end) {
      const backdrop = child.querySelector('.backdrop')
      const letters = child.querySelector('.bubble-copy').children
      gsap.set(backdrop, { scale: 0.5, autoAlpha: 0 })
      gsap.set(letters, { autoAlpha: 0 })
      let bTransition
      this.timeline.add(() => { gsap.set(backdrop, { rotation: child.dataset.rotation }); this.tweens.push(gsap.to(backdrop, 0.25, { scale: 1, autoAlpha: 1, ease: 'power1.out' })) }, start)
      this.timeline.add(() => this.tweens.push(gsap.to(backdrop, 0.25, { autoAlpha: 0, ease: 'power1.out' })), end)

      this.timeline.add(() => {
        bTransition = gsap.to(letters, 0.1, { autoAlpha: 1, ease: 'power1.out', stagger: 0.025, onComplete: () => this.waitingAnimation = false })
        this.tweens.push(bTransition)
        this.waitingAnimation = true
      }, start)

      this.timeline.add(() => {
        if (bTransition) {
          bTransition.pause()
        }
        this.waitingAnimation = false
        this.tweens.push(gsap.to(letters, 0.25, { autoAlpha: 0, ease: 'power1.out' }))
      }, end)
    },

    timelineIntro (child, start, end) {
      console.log('timelineIntro')
      const scale = this.mobile ? 0.45 : 1
      this.timeline.to(this.intro, 20 / 30, { alpha: 1 }, start)
      this.timeline.to(this.intro.scale, 20 / 30, { x: 1 * scale, y: 1 * scale }, start)
      this.timeline.add(() => {
        this.intro.gotoAndStop(1)
        this.intro.anchor.y = 0.58
      }, start + 19 / 30)
      this.timeline.fromTo(this.burst.scale, 20 / 30, { x: 0.8 * scale, y: 0.8 * scale }, { x: 1 * scale, y: 1 * scale }, start + 22 / 30)
      this.timeline.to(this.burst, 20 / 30, { alpha: 1 }, start + 22 / 30)
      this.timeline.to(this.introContainer.scale, 6, { x: 1, y: 1 }, start + 22 / 30)
      this.timeline.to(this.introContainer, 0.25, { y: '-=50', alpha: 0 }, start + 22 / 30 + 5.45)
    },

    timelineOutro (child, start, end) {
      // this.timeline.add(() => {
      //   this.timeoutQueue.push(setTimeout(() => {
      //     this.playOutro()
      //   }, 500))
      // }, start)
    },

    onClickExperience (e) {
      this.clickAttachments.forEach(attachment => {
        const bounds = attachment.child.getBoundingClientRect()
        if (e.clientX > bounds.left && e.clientX < bounds.right && e.clientY > bounds.top && e.clientY < bounds.bottom) {
          attachment.cb(attachment.child)
        }
      })
    },

    onClickLegal (child) {
      const start = parseInt(child.dataset.start)
      const end = parseInt(child.dataset.end)
      const time = this.video.currentTime * 30
      if (time >= start && time <= end) {
        window.open('https://www.youtube.com/watch?v=6LMgSRewsuQ', '_blank')
      }
    },

    random () {
      const x = Math.sin(this.seed++) * 10000
      return x - Math.floor(x)
    },

    render () {
      const renderTime = performance.now() - (this.lastRender || 0)
      this.targetT = ((this.targetT || 0) + renderTime * 0.00001) % 1
      if (this.started) {
        // console.log(this.video.currentTime, this.video.currentTime >= Breakpoints[this.breakpoint], this.transitioning, this.waiting)
        if (!(this.app.renderer instanceof PIXI.CanvasRenderer)) {
          this.renderParticles(renderTime)
        }
        this.checkBreakpoint()
        this.checkSound()
        this.updateTimeline()
        this.updateSection()
      }
      this.updateVideoOpQueue()
      this.breakpoint = this.getNextBreakpoint()
      this.sound = this.getNextSound()
      this.canScroll = this.video.paused && this.video.currentTime >= (this.breakpoint.time - 0.01) && this.breakpoint.index !== (Breakpoints.length - 1)
      this.lastRender = performance.now()
      // console.log(`video.paused ${this.video.paused}`)
      // console.log(`video time ${this.video.currentTime}`)
      // if (this.video.currentTime >= this.video.duration - 1) {
      //   console.log(`video time ${this.video.currentTime}`)
      //   console.log('video ended')
      //   console.log(`video duration ${this.video.duration}`)
      //   // this.video.pause()
      // }
    },

    updateVideoOpQueue () {
      if (this.videoOpQueue.length > 0) {
        // console.log(this.videoOpQueue.map(op => op.name))
        const op = this.videoOpQueue[0]
        if (op.resolved) {
          this.videoOpQueue.shift()
        } else if (!op.running) {
          op.fn()
        }
      }
    },

    updateTimeline () {
      if (this.timeline) {
        this.timeline.time(this.video.currentTime, false)
      }
    },

    updateSection () {
      let index = this.sections.findIndex(k => this.video.currentTime + 0.01 <= k.time)
      index = index >= 0 ? (index - 1) : (this.sections.length - 1)
      // if (this.sectionId !== index) {
      //   console.log('updating section from' , this.sectionId, index)
      //   console.log('currentTime = ' + this.video.currentTime)
      //   // if (this.sectionId === 6 && index === 0) {
      //   //   console.log('preventing')
      //   //   return // just not allowing this switch over -- this probably won't work
      //   // }
      // }
      this.sectionId = index
    },

    renderParticles (renderTime) {
      if (
        (this.breakpoint.index <= Labels.MUSHY) ||
        (this.breakpoint.index >= Labels.POST_SLIDE && this.breakpoint.index <= Labels.HPT_1) ||
        (this.breakpoint.index >= Labels.BENNY_1 && this.breakpoint.index <= Labels.MARVELOUS) ||
        (this.breakpoint.index >= Labels.AGAIN)
      ) {
        this.particleSneak = Math.max(0, Math.min(1, this.particleSneak + renderTime * 0.0002))
      } else {
        this.particleSneak = 0
      }
      if (this.video.currentTime >= Times[Labels.BENNY_1] / 30 + 1 / 30 && this.video.currentTime < (Times[Labels.BENNY_2] / 30 + 13 / 30)) {
        this.zoomScaler = Math.max(0, Math.min(2, (this.zoomScaler || 0) + 0.005 * renderTime))
      } else {
        this.bumped = false
        this.app.stage.filters = []
        // if (this.breakpoint.index < Labels.BENNY_2 || this.video.currentTime > 38.5) {
          this.zoomScaler = Math.max(0, Math.min(2, (this.zoomScaler || 0) - 0.0035 * renderTime))
        // }
      }
      this.frame = (this.frame || 0) + 1
      this.tu = (this.tu || 0) + (renderTime / 120)
      this.tu = this.tu % (Math.PI * 1.8)
      if (this.particleContainer) {
        this.particleContainer.scale.x = this.zoomScaler + 1
        this.particleContainer.scale.y = this.zoomScaler + 1
        this.particleContainer.x = this.zoomScaler * -500
        this.particleContainer.y = this.zoomScaler * -600
        this.particleContainer.children.forEach((child, i) => {
          child.t = (child.t + renderTime * ((0.001 / child.points.length) * child.scale.x)) % 1
          const p = child.curve.getPointAt(child.t)
          child.x = p[0] * (this.mobile ? 810 : 1920)
          child.y = p[1] * 1080
          child.scale.x = (p[2] ** 8 * 0.15 + 0.015) * this.particleSneak
          child.scale.y = (p[2] ** 8 * 0.15 + 0.015) * this.particleSneak
          child.__glow.alpha = ((Math.sin(this.tu) * child.pulseSpeed) * 0.5 + 0.5) * 0.5 + 0.3
          child.rotation += child.spin * child.speed
        })
        this.particleContainer.children.sort((a, b) => a.scale.x - b.scale.x)
      }
    },

    checkBreakpoint () {
      const breakpoint = this.getNextBreakpoint()
      if (breakpoint.time <= this.video.currentTime) {
        if (!breakpoint.opFired && !this.transitioning) {
          breakpoint.opFired = true
          if (breakpoint.index >= Breakpoints.length - 2) {
            if (breakpoint.index === Breakpoints.length - 1) {
              this.playOutro()
            } else {
              // console.log('setting final time')
              this.setTime(this.video.duration - 0.01)
            }
          } else {
            this.setTime(breakpoint.time)
          }
        }
      }
    },

    checkSound () {
      this.sounds.filter(sound => sound.playing).forEach(sound => {
        if (sound.end / 30 <= this.video.currentTime) {
          sound.playing = false
          AudioManager.stop(sound.key)
        }
      })
      const sound = this.getNextSound()
      if (sound) {
        if (sound.start / 30 <= this.video.currentTime) {
          if (!sound.triggered && !this.transitioning) {
            sound.triggered = true
            sound.playing = true
            if (sound.end) {
              AudioManager.playTrack(sound.key, 0.25)
            } else {
              AudioManager.playSound(sound.key, 0.25)
            }
          }
        }
      }
    },

    didScroll (direction) {
      // console.log(!!this.waiting, !!this.waitingAnimation, !!this.justScrolled, this.video.currentTime)
      const breakpoint = this.getNextBreakpoint()
      if (!this.waitingAnimation && !this.justScrolled) {
        this.justScrolled = true
        setTimeout(() => this.justScrolled = false, 350)
        if (direction === 'down') {
          if (this.enteredPackagingSection) {
            this.scrollThroughPackagingSection()
          } else if (this.video.paused && this.canScroll) {
            this.waiting = false
            breakpoint.triggered = true
            this.playVideo()
          } else if (this.video.currentTime >= (Times[Labels.HPT_4] / 30 + 30 / 30) && this.video.currentTime <= (Times[Labels.HPT_5] / 30 - 5 / 30)) {
            this.setTime(Times[Labels.HPT_5] / 30 - 5 / 30).then(this.playVideo())
          }
        }
      }
      if (direction === 'up') {
        let bp = Breakpoints[Math.max(0, breakpoint.index - 1)]
        while (bp.skip) {
          bp = Breakpoints[Math.max(0, bp.index - 1)]
        }
        this.transition(bp.time)
        this.rewind = true
        clearTimeout(this.rewindTimeout)
        this.rewindTimeout = setTimeout(() => this.rewind = false, 2000)
      }
    },

    scrollThroughPackagingSection () {
      this.waitingAnimation = true
      this.timeoutQueue.push(setTimeout(() => this.waitingAnimation = false, 1000))
      this.waiting = false
      this.packagingState++
      if (this.packagingState === 1) {
        this.tweens.push(gsap.fromTo(this.$refs.scaleBubble, 0.5, { scale: 1 }, { scale: 500, ease: 'power4.in' }))
        AudioManager.playSound('product-reveal', 0.25)
        this.timeoutQueue.push(setTimeout(() => {
          this.inPackagingSection = true
          this.tweens.push(gsap.fromTo(this.$refs.packaging, 0.35, { scale: 0.25, autoAlpha: 0 }, { scale: 1, ease: 'power2.in', autoAlpha: 1 }))
        }, 200))
      }
      if (this.packagingState === 2) {
        AudioManager.playSound('whoosh-2', 0.25)
      }
      if (this.packagingState > 2) {
        AudioManager.playSound('whoosh', 0.25)
        this.enteredPackagingSection = false
        this.getNextBreakpoint().triggered = true
        this.playVideo()
      }
      if (this.packagingState > 3) {
        this.inPackagingSection = false
      } else {
        this.timeoutQueue.push(setTimeout(() => this.waiting = true, 500))
      }
    },

    attachScroll () {
      this.$refs.scroller.scrollTop = 2000
      setTimeout(() => {
        this.$refs.scroller.addEventListener('scroll', this.onScroll)
      }, 50)
    },

    detachScroll () {
      this.$refs.scroller.removeEventListener('scroll', this.onScroll)
    },

    async onScroll () {
      if (!this.scrolling) {
        this.scrolling = true
        this.didScroll(Math.sign(this.$refs.scroller.scrollTop - 2000) === -1 ? 'up' : 'down')
        this.detachScroll()
        this.scrollCount++
        setTimeout(async () => {
          this.scrollCount++
          await Vue.nextTick()
          await Vue.nextTick()
          this.scrolling = false
          this.attachScroll()
        }, 100)
      }
    },

    isMobile () {
      return (window.innerWidth / window.innerHeight) < 1
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #779A30;
}
.container {
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  width: 100%;
  height: 100%;
  overflow: hidden;
  * {
    user-select: none;
  }
  &.desktop {
    @media (min-aspect-ratio: 16/9) {
      canvas, .still-container img {
        width: 100vw;
      }
    }
    @media (max-aspect-ratio: 16/9) {
      canvas, .still-container img {
        height: 100vh;
      }
    }
  }
  &.mobile {
    .hover-copy {
      &.ch1 {
        font-size: 4em;
        top: (6.25em/0.75);
        left: (6.35em/0.75);
      }
      &.ch2 {
        font-size: 4em;
        top: (6em/0.75);
        left: (6.5em/0.75);
      }
      &.ch3 {
        font-size: 4em;
        top: (3.8em/0.75);
        left: (6.5em/0.75);
      }
      &.brs1 {
        top: (12em/0.75);
        left: (21em/0.75);
      }
      &.brs2 {
        top: (12em/0.75);
        left: (17em/0.75);
      }
      &.ch4 {
        top: (7em/0.75);
        left: (8.5em/0.75);
      }
      &.brs1 {
        top: 15em;
        left: 11.25em;
      }
      &.brs2 {
        top: 15em;
        left: 11.25em;
      }
      &.end-line {
        top: 13.5em;
      }
      &.source {
        top: calc(50% + 35vh);
        left: 50%;
      }
    }
    .bubble {
      &.bubble1 {
        top: 10em;
        left: 9em;
        width: 13em;
        height: 13em;
        transform-origin: 74% 77%;
        .bubble-copy {
          padding: 0 3em;
        }
      }
      &.bubble2 {
        top: 17.75em;
        left: 11.5em;
        width: 13em;
        height: 13em;
        .bubble-copy {
          padding: 0 3em;
        }
      }
      &.bubble3 {
        top: 15em;
        left: 9.25em;
        width: 11em;
        height: 11em;
        .bubble-copy {
          padding: 0 1.75em;
        }
      }
    }
    .overlay {
      width: (50.625em/0.75);
      height: (67.5em/0.75);
    }
    @media (min-aspect-ratio: 3/4) {
      canvas, .still-container img {
        width: 100vw;
      }
    }
    @media (max-aspect-ratio: 3/4) {
      top: 50%;
      transform: translateY(-50%);
      max-height: 180vw;
      canvas, .still-container img {
        max-height: 180vw;
        height: 100vh;
      }
    }
    .nav-dots {
      left: 50%;
      top: auto;
      bottom: 20px;
      width: 100%;
      text-align: center;
      transform: translateX(-50%);
    }
    .dot {
      width: 15px;
      height: 15px;
      display: inline-block;
      &:not(:last-of-type) {
        margin-bottom: 0px;
        margin-right: 20px;
      }
      &.active {
        &::after {
          top: -4px;
          left: -4px;
          width: 19px;
          height: 19px;
        }
      }
    }
  }
}
.mute-icon {
  position: absolute;
  z-index: 10;
  top: 10px;
  right: 10px;
  width: 48px;
  cursor: pointer;
  filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.5));
}
.loading-container {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  align-content: center;
  align-items: center;
  z-index: 100;
  background: #779A30;
  font-size: 3em;
}
.loading-inner {
  margin: 0 auto;
  text-align: center;
  .tap {
    font-size: 0.5em;
    margin-top: 0.5em;
  }
}
canvas, .still-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
.still-container img {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  // opacity: 0.15;
}
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(30px);
  }
  40% {
    transform: translateY(0px);
  }
  60% {
    transform: translateY(15px);
  }
}
.scroll-indicator {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 5em;
  &.active {
    cursor: pointer;
    img {
      opacity: 1;
    }
  }
  img {
    opacity: 0;
    transition: 0.5s opacity;
    animation: bounce 2s infinite;
    width: 5em;
  }
}
.nav-dots {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.5));
}
.dot {
  position: relative;
  width: 12px;
  height: 12px;
  border-radius: 99px;
  cursor: pointer;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
  &.active {
    &::after {
      content: '';
      position: absolute;
      top: -5px;
      left: -5px;
      width: 18px;
      height: 18px;
      border: 2px solid #fff;
      border-radius: 99px;
    }
  }
}
.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 120em;
  height: 67.5em;
  transform: translate(-50%, -50%);
  overflow: hidden;
  pointer-events: none;

  // @media (max-width: 767px) {
  //   font-size: 1.4vw !important;
  // }
}
.hover-copy,
.packaging-slide::v-deep p {
  font-size: 3em;
  line-height: 1.1em;
}
.hover-copy {
  position: absolute;
  text-align: center;
  text-transform: none;
  text-shadow: 0px 0.125em 0.125em rgba(73, 141, 182, 0.7);
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  &.alt {
    // font-weight: 700;
    // font-family: 'Gilroy';
  }
  &.ch1 {
    left: 19.9em;
  }
  &.ch2 {
    top: 9.6em;
    left: 22.4em;
  }
  &.ch3 {
    top: 6em;
    left: 22em;
  }
  &.brs1 {
    top: 12em;
    left: 21em;
  }
  &.brs2 {
    top: 12em;
    left: 17em;
  }
  &.source {
    position: fixed;
    z-index: 10;
    font-family: 'Gilroy';
    font-weight: 700;
    width: auto;
    text-shadow: none;
    color: #fff;
    left: calc(50% + 45vw);
    top: calc(50% + 45vh);
    .hover-line {
      border-bottom: 0.1em solid;
      border-color: #E7E18D;
      cursor: pointer;
      font-size: 0.75em;
      line-height: 0.95em;
    }
  }
}
.gradient {
  background: radial-gradient(circle, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0) 60%);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.bubble-copy {
  display: table-cell;
  vertical-align: middle;
  position: relative;
  z-index: 1;
}
.bubble {
  font-family: 'Gilroy';
  display: table;
  position: absolute;
  text-align: center;
  text-transform: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3em;
  line-height: 1.1em;
  font-weight: 900;
  color: #759a2f;
  width: 14em;
  height: 14em;
  // white-space: pre-wrap;
  .backdrop {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.90;
    width: 100%;
    height: 100%;
    .circle {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 9999px;
      background: #fff;
    }
    .triangle {
      position: absolute;
      top: calc(50% - 1em);
      right: -1.35em;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 1em 0 1em 1.5em;
      border-color: transparent transparent transparent #fff;
    }
  }
  &.bubble1 {
    top: 9.75em;
    left: 23.75em;
    transform-origin: 72.7% 71.1%;
    // transform-origin: 10.1395em 9.835em;
    .backdrop {
      transform: rotate(-10deg);
    }
    .bubble-copy {
      padding: 0 2.5em;
    }
  }
  &.bubble2 {
    top: 11.75em;
    left: 22.5em;
    .backdrop {
      transform: rotate(-160deg);
    }
    .bubble-copy {
      padding: 0 2.5em;
    }
  }
  &.bubble3 {
    top: 9.75em;
    left: 21.75em;
    .backdrop {
      transform: rotate(-15deg);
    }
    .bubble-copy {
      padding: 0 2.5em;
    }
  }
}
.bubble-letter {
  &.superscript {
    display: inline-block;
    font-size: 0.75em;
    vertical-align: top;
    margin-top: -0.125em;
  }
}
.packaging-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.scroll-container {
  width: 120%;
  height: 100%;
  overflow-y: scroll;
}
.scroll-inner {
  width: 100%;
  height: 4000px;
  background: transparent;
}
.debug {
  position: absolute;
  width: 10em;
  height: 10em;
  background: red;
  top: 25em;
  left: 54.75em;
}
.spacer {
  height: 0.5em;
}
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
}
.loader {
  color: #ffffff;
  font-size: 10px;
  margin: 0px auto;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loader:before,
.loader:after {
  content: '';
  position: absolute;
  top: 0;
}
.loader:before {
  left: -3.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 3.5em;
}
@-webkit-keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}

</style>
